import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../resources/css/block_ClubLeaderBoard.css';

import Common from '../../../../Shared/Common';
import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { SSDComps } from '../../../../Brands/SSD/Start';


export const Comps_SubmitClubRecord = (props) => {
    return (
        <SSDComps>
            <Comps_SubmitClubRecordContent />
        </SSDComps>
    );
}
export default Comps_SubmitClubRecord;

export const Comps_SubmitClubRecordContent = (props) => {

    const [comp, setComp] = useState("Select Competition");
    const [fishTypeSpecies, setFishTypeSpecies] = useState("Select Fish Specie");
    const [fishTypePelagic, setFishTypePelagic] = useState("Select Pelagic Fish");
    const [competitionName, setCompetitionName] = useState("Select an Event");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("");
    const [points, setPoints] = useState("");
    const [weight, setWeight] = useState("");
    const [length, seLength] = useState("");
    const [year, setYear] = useState("2026");

    const [inputFishWeightFileKey, setInputFishWeightFileKey] = useState("");
    const [inputDiverAndFishFileKey, setInputDiverAndFishFileKey] = useState("");
    const [inputScoreSheetFileKey, setInputScoreSheetFileKey] = useState("");

    const [fishWeightFile, setFishWeightFile] = useState(null);
    const [diverAndFishFile, setDiverAndFishFile] = useState(null);
    const [diverScoreSheetFile, setScoreSheetFile] = useState(null);

    const [errorMessage, setErrorMessage] = useState();
    const [successMessage, setSuccessMessage] = useState();
    const [loading, setLoading] = useState();

    useEffect(() => {
    },[]);

    let onCompChange = function (item, event) {
        setComp(item.target.value);
        Common.trace(item.target.value);
    };
    let onFishTypeSpeciesChange = function (item, event) {
        setFishTypeSpecies(item.target.value);
        Common.trace(item.target.value);
    };
    let onFishTypePelagicChange = function (item, event) {
        setFishTypePelagic(item.target.value);
        Common.trace(item.target.value);
    };
    let oncompetitionNameChange = function (item, event) {
        setCompetitionName(item.target.value);
        Common.trace(item.target.value);
    };


    let onFirstNameChange = function (item, event) {
        setFirstName(item.target.value);
    };
    let onLastNameChange = function (item, event) {
        setLastName(item.target.value);
    };
    let onEmailChange = function (item, event) {
        setEmail(item.target.value);
    };
    let onDateChange = function (item, event) {
        setDate(item.target.value);
    };
    let onLocationChange = function (item, event) {
        setLocation(item.target.value);
    };
    let onCountryChange = function (item, event) {
        setCountry(item.target.value);
    };


    let onPointsChange = function (item, event) {
        setPoints(item.target.value);
    };
    let onWeightChange = function (item, event) {
        setWeight(item.target.value);
    };
    let onLengthChange = function (item, event) {
        seLength(item.target.value);
    };


    let onWeightFileChangege = function (item, event) {
        setFishWeightFile(item.target.files[0]);
    };
    let onDiverAndFishFileChange = function (item, event) {
        setDiverAndFishFile(item.target.files[0]);
    };
    let onScoreSheetFileChange = function (item, event) {
        setScoreSheetFile(item.target.files[0]);
    };


    let onNumberKeyPress = function (event) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };


    let save = async () => {
        setErrorMessage("");
        setSuccessMessage("");
        setLoading(true);

        let payload = {
            compName: comp,
            diverName: firstName + " " + lastName,
            email: email,
            date: date,
            location: location,
            country: country,
            points: points,
            weight: weight,
            length: length,
            year: year,
            fishSpecies: fishTypeSpecies,
            fishPelagic: fishTypePelagic,
            eventName: competitionName,
        };
        Common.trace(payload);

        let errorMessage = null;
        setErrorMessage(errorMessage);

        const formData = new FormData();
        formData.append('fishWeightPhoto', fishWeightFile);
        formData.append('diverAndFishPhoto', diverAndFishFile);
        formData.append('scoreSheetPhoto', diverScoreSheetFile);
        formData.append("payload", JSON.stringify(payload));

        if ((comp == "Club Species") || (comp == "Pucko Challenge")) {

            if ((!fishWeightFile) || (!diverAndFishFile)) {
                errorMessage = "Both Photos need to Selected"
            } else {

                if ((payload.compName == "")
                    || (payload.diverName == "")
                    || (payload.email == "")
                    || (payload.date == "")
                    || (payload.location == "")
                    || (payload.country == "")
                    || (payload.weight == "")
                    || (payload.length == "")) {

                    errorMessage = "All fields are mandatory."

                } else {
                    if (((comp == "Club Species") && (payload.fishSpecies == "Select Fish Specie"))
                        || ((comp == "Pucko Challenge") && (payload.fishPelagic == "Select Pelagic Fish"))) {
                        errorMessage = "Select the Fish from the list"
                    } else {
                        formData.append('fishWeightPhoto', fishWeightFile);
                        formData.append('diverAndFishPhoto', diverAndFishFile);
                        formData.append('scoreSheetPhoto', null);
                        formData.append("payload", JSON.stringify(payload));
                    }
                }
            }

        } else { //comp == "Record Comp Points"

            if ((!diverScoreSheetFile)) {
                errorMessage = "Upload the score sheet"
            } else {

                if ((payload.compName) && (payload.compName != "")
                    || (payload.diverName != "")
                    || (payload.email != "")
                    || (payload.points != "")) {

                    errorMessage = "All fields are mandatory"

                } else {
                    if (payload.eventName == "Select an Event"){
                        errorMessage = "Select an Event / Comp from the list"
                    } else {
                        formData.append('fishWeightPhoto', null);
                        formData.append('diverAndFishPhoto', null);
                        formData.append('scoreSheetPhoto', diverScoreSheetFile);
                        formData.append("payload", JSON.stringify(payload));
                    }
                }
            }
        }

        if (errorMessage == null) {

            try {
                const response = await fetch('/api/Clubs/uploadPhoto', {
                    method: 'POST',
                    body: formData,
                });
                 if (response.ok) {
                    setSuccessMessage('Upload completed successfully!');
                } else {
                    errorMessage = "Failed to upload the Photos";
                }
            } catch (error) {
                errorMessage = "Failed to upload the Photos. Please Try again later.";
                Common.trace('Upload error:', error);
            }
        }

        if (errorMessage != null) {
            setErrorMessage(errorMessage);
        }
        setLoading(false);
    };


    let actionCallBack = function (data, callbackData) {
    }

    let actionCallbackError = function (data, callbackData) {
        Common.trace(data);
        Common.trace(callbackData);
    }

    let reset = function () {

        setFishTypeSpecies("");
        setFishTypePelagic("");
        setCompetitionName("");
        setFirstName("");
        setLastName("");
        setEmail("");
        setDate("");
        setLocation("");
        setCountry("");
        setPoints("");
        setWeight("");
        seLength("");

        setInputFishWeightFileKey("");
        setInputDiverAndFishFileKey("");
        setInputScoreSheetFileKey("");
    };

    return (
        <Block name="submissions" isAlt={false}>
            <TextHeader 
                text="Sanc Souci Dolphins All Year Competitions"
            />
            <TextTitle
                text="Here you can submit your catch and points for the compeitions below which will crown the new Sanc Souci Doplphins Champs at the end of year."
            />
            <TextTitle
                text="Currently the 3 below Comps are on. Read and comply with the rules and submit your catch."
            />
            <TextTitle
                text={<span>All submissions and results are accessible in the  <Link to="/Competitions/ClubLeaderBoard">Comps Leaderboard</Link></span>}
            />
            <Row>
                <Col lg="4">
                    <SubmissionCategory
                        name="Pucko Challenge"
                        description="Largest pelagic fish"
                        longDescription="The Pucko challenge; running since 2001 rewards the biggest pelagic fish caught by divers."
                        location="Anywhere in the world"
                        hasPoints={false}
                    />
                </Col>
                <Col lg="4">
                    <SubmissionCategory
                        name="Club Species"
                        description="Biggest fish for the selected Club Species"
                        longDescription="Over 15 species in this category (widely available in sydney). Who can shoot the biggest fish within each category."
                        location="NSW only"
                        hasPoints={false}
                    />
                </Col>
                <Col lg="4">
                    <SubmissionCategory
                        name="Official Comps"
                        description="Track points from official Competitions"
                        longDescription="After each official comp; enter your points to become the Club Champion!!!"
                        location="NSW & QLD official competitions"
                        hasPoints={true}
                     />
                </Col>
            </Row>

            <Row className="spacing-row">
                <Col>

                    <Alert color="info">
                        <Row>
                            <Col lg={{ size: 8, offset: 2 }} align="center">
                                <FormGroup>

                                    <Label for="competition">
                                        <h2>Step 1. Select the Competition</h2>
                                    </Label>
                                    <Input id="competition" name="competition" type="select"
                                        value={comp}
                                        onChange={onCompChange}>
                                        <option>Select Competition</option>

                                        <option>Pucko Challenge</option>
                                        <option>Club Species</option>
                                        <option>Comp Points</option>
                                    </Input>

                                </FormGroup>
                            </Col>
                        </Row>

                    </Alert>
                </Col>
            </Row>


            <Row>
                <Col>
                    <Container className="alert alert-info">
                        <Row>
                            <Col lg={{ size: 10, offset: 1 }} align="center">
                                <FormGroup>

                                    <Label for="">
                                        <h2>Step 2. Upload Photo Evidence</h2>
                                    </Label>
                                   
                                </FormGroup>
                                {((comp == "Pucko Challenge") || (comp == "Club Species")) && (
                                    <Fragment>
                                        <FormGroup>
                                            <Label for="diverAndFishFile">Upload Photo with your catch</Label>
                                            <Input id="diverAndFishFile" type="file" onChange={onDiverAndFishFileChange} key={inputDiverAndFishFileKey} accept="image/*" />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="fishWeightFile">Upload a photo fish weight / scale</Label>
                                            <Input id="fishWeightFile" type="file" onChange={onWeightFileChangege} key={inputFishWeightFileKey} accept="image/*" />
                                        </FormGroup>
                                    </Fragment>
                                )}
                                {((comp == "Comp Points")) && (
                                    <Fragment>
                                        <FormGroup>
                                            <Label for="scoreSheetFile">Upload the Scoresheet</Label>
                                            <Input id="scoreSheetFile" type="file" onChange={onScoreSheetFileChange} key={inputScoreSheetFileKey} accept="image/*" />
                                        </FormGroup>
                                    </Fragment>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            
            <Row>
                <Col>
                    <Container className="alert alert-info">
                        <Row>
                            <Col lg={{ size: 10, offset: 1 }} align="center">
                                <FormGroup>

                                    <Label for="">
                                        <h2>Step 3. Enter Diver and Trophy Details</h2>
                                    </Label>

                                </FormGroup>
                            </Col>
                        </Row>

                        {comp != "Select Competition" && (
                       
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                        <Input type="text" value={firstName} onChange={onFirstNameChange} placeholder="First Name" maxlength="50"/>
                                </FormGroup>

                                <FormGroup>
                                        <Input type="text" value={lastName} onChange={onLastNameChange} placeholder="Last Name" maxlength="50" />
                                </FormGroup>

                                <FormGroup>
                                        <Input type="text" value={email} onChange={onEmailChange} placeholder="Email Address" maxlength="100" />
                                </FormGroup>
                            </Col>

                            <Col lg="6">

                                {comp == "Club Species" && (
                                    <Fragment>

                                        <FormGroup>
                                            <Input id="fishTypeSpecies" name="fishTypeSpecies" type="select"
                                                    value={fishTypeSpecies}
                                                    onChange={onFishTypeSpeciesChange}>

                                                <option>Select Fish Specie</option>

                                                <option>Bonito</option>
                                                <option>Bream</option>
                                                <option>Cray</option>
                                                <option>Dolphin Fish (Mahi Mahi)</option>
                                                <option>Drummer (Black)</option>
                                                <option>Kingfish</option>
                                                <option>Morwong (Red)</option>
                                                <option>Morwong (Blue)</option>
                                                <option>Mulloway</option>
                                                <option>Red Rocky (Cod Red Rock)</option>
                                                <option>Mackarell (any)</option>
                                                <option>Salmon</option>
                                                <option>Snapper</option>
                                                <option>Wahoo</option>
                                            </Input>
                                        </FormGroup>
                                    </Fragment>
                                )}

                                {comp == "Pucko Challenge" && (
                                    <Fragment>
                                        <FormGroup>
                                            <Input id="fishTypePelagics" name="fishTypePelagics" type="select"
                                                    value={fishTypePelagic}
                                                    onChange={onFishTypePelagicChange}>

                                                <option>Select Pelagic Fish</option>
                                                <option>Cobia</option>
                                                <option>Dolphin Fish (Mahi Mahi)</option>
                                                <option>Kingfish</option>
                                                <option>Mulloway</option>
                                                <option>Mackarell (Spanish)</option>
                                                <option>Mackarell (Grey)</option>
                                                <option>Marlin</option>
                                                <option>Sailfish</option>
                                                <option>Swordfish</option>
                                                <option>Tuna (dogtooth)</option>
                                                <option>Tuna (yellow-fin)</option>
                                                <option>Tuna (blue-fin)</option>
                                                <option>Tuna (long-fin)</option>
                                            </Input>
                                        </FormGroup>
                                    </Fragment>
                                )}

                                {((comp == "Pucko Challenge") || (comp == "Club Species")) && (
                                    <Fragment>
                                        <FormGroup>
                                            <Input type="date" value={date} onChange={onDateChange} placeholder="When / Date" required />
                                        </FormGroup>

                                        <FormGroup>
                                                <Input type="text" value={location} onChange={onLocationChange} placeholder="location (headland / Zone)" maxlength="50" />
                                        </FormGroup>

                                        <FormGroup>
                                                <Input type="text" value={country} onChange={onCountryChange} placeholder="location (Country)" maxlength="50" />
                                        </FormGroup>

                                        <FormGroup>
                                                <Input type="text" value={weight} onChange={onWeightChange} placeholder="weight in grams (e.g. 15250 for 15 kg and 250 grms)" maxlength="6" onKeyPress={onNumberKeyPress} />
                                        </FormGroup>

                                        <FormGroup>
                                                <Input type="text" value={length} onChange={onLengthChange} placeholder="length in cm (e.g. 125)" maxlength="3" onKeyPress={onNumberKeyPress} />
                                        </FormGroup>

                                    </Fragment>
                                )}

                                {comp == "Comp Points" && (
                                    <Fragment>
                                        <FormGroup>
                                            <Input id="competitionName" name="competitionName" type="select"
                                                    value={competitionName}
                                                    onChange={oncompetitionNameChange}>
                                                <option>Select an Event</option>

                                                <option>Alliman - January</option>
                                                <option>Alliman - Febrary</option>
                                                <option>Alliman - March</option>
                                                <option>Alliman - April</option>
                                                <option>Alliman - May</option>
                                                <option>Alliman - June</option>
                                                <option>Alliman - July</option>
                                                <option>Alliman - August</option>
                                                <option>Alliman - September</option>
                                                <option>Alliman - October</option>
                                                <option>Alliman - November</option>
                                                <option>Alliman - December</option>

                                                <option>Southern Zone - Huskinsson</option>
                                                <option>Southern Zone - Botany Bay</option>
                                                <option>Southern Zone - Port Kembla</option>
                                                <option>Southern Zone - Kiama</option>
                                                <option>Southern Zone - Bendalong</option>
                                                <option>Southern Zone - Currarong</option>

                                                <option>South Coast Championship - Ulladulla</option>
                                                <option>South Coast Championship - Shell Harbour</option>
                                                <option>Far South Coast Championship - Narooma</option>
                                                <option>Pacific Coast Championship - Port Stephens</option>

                                                <option>Blue Water Classic</option>
                                                <option>Eden Spearfishing Challenge</option>

                                                <option>Canada Cup</option>
                                                <option>Cloughy Challenge</option>

                                            </Input>
                                        </FormGroup>

                                        <FormGroup>
                                                <Input id="pointsInComp" type="text" value={points} onChange={onPointsChange} placeholder="Total Points in Competition" maxlength="5" onKeyPress={onNumberKeyPress} />
                                        </FormGroup>

                                    </Fragment>
                                )}

                            </Col>
                            </Row>

                        )}
                    </Container>
                </Col>

            </Row>

            {(loading) && (
                <Row>
                    <Col align="center">
                        <Spinner animation="border" variant="success" />
                    </Col>
                </Row>
            )}
            {(successMessage) && (
                <Row>
                    <Col align="center">
                        <Alert color="success">
                            <b>{successMessage}</b>
                        </Alert>
                    </Col>
                </Row>
            )}
            {(errorMessage) && (
                <Row>
                    <Col align="center">
                        <Alert color="danger">
                            <b>{errorMessage}</b>
                        </Alert>
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    {comp != "Select Competition" && (
                        <Container className="alert alert-warning">
                            <Col lg="12" align="right">

                                <FormGroup>

                                    <Button color="danger" onClick={reset}>
                                        <FontAwesomeIcon icon={faTrash} /> Reset
                                    </Button>
                                    &nbsp;
                                    <Button color="primary" onClick={save} disabled={loading}>
                                        <FontAwesomeIcon icon={faSave} /> Submit
                                    </Button>

                                </FormGroup>

                            </Col>
                        </Container>
                    )}
                </Col>
            </Row>

        </Block>
    );
}

export const SubmissionCategory = (props) => {

    return (
        <Block name="submissions" isAlt={false}>
            <TextHeader
                text={<Alert color="info">{props.name}</Alert>}
            />
            <Row>
                <Col>
                    <Alert color="secondary">
                        <TextTitle
                            text={<h3>{props.description}</h3>}
                        />
                        {props.longDescription}
                    </Alert>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ListGroup>
                        <ListGroupItem active>
                            <b>{props.location}</b>
                        </ListGroupItem>
                        {!props.hasPoints && (
                            <Fragment>
                                <ListGroupItem>Can make multiple submissions</ListGroupItem>
                                <ListGroupItem>Catch needs to be un-assisted</ListGroupItem>
                                <ListGroupItem>Attach a photo that clearly shows the fish weight on the scale</ListGroupItem>
                                <ListGroupItem>Attach a photo of yourself with the fish</ListGroupItem>
                            </Fragment>
                        )}
                        {props.hasPoints && (
                            <Fragment>
                                <ListGroupItem>Attach a photo of the competition sheet results</ListGroupItem>
                            </Fragment>
                        )}
                    </ListGroup>

                </Col>
                
            </Row>
        </Block>
    );
}

